import { useState, useCallback, useRef } from 'react'
import _ from 'lodash'

const BASE_BAR_WIDTH_PERCENT = 0.5
const BASE_BAR_AMOUNT = 20

export const useChartSizing = (data) => {
  const [barSize, setBarSize] = useState(null)
  const [tooltipCursorWidth, setTooltipCursorWidth] = useState(null)
  const chartRef = useRef(null)

  const updateBarAndCursorWidth = useCallback(() => {
    const dataSize = _.size(data)
    const {
      tooltipAxisBandSize: originTooltipAxisBandSize = 0,
      tooltipTicks = []
    } = _.get(chartRef.current, 'state', {})
    let tooltipCursorWidth = originTooltipAxisBandSize
    if (tooltipCursorWidth === 0) {
      const manualCalcCursorWidth = Math.abs(
        _.get(tooltipTicks, '[1].coordinate') - _.get(tooltipTicks, '[0].coordinate')
      )
      if (!_.isNaN(manualCalcCursorWidth) && manualCalcCursorWidth > 0) {
        tooltipCursorWidth = manualCalcCursorWidth
      }
    }

    const percent = BASE_BAR_WIDTH_PERCENT + (_.round(dataSize / BASE_BAR_AMOUNT) * 0.1)
    const barSize = tooltipCursorWidth * (percent >= 0.9 ? undefined : percent)

    setTooltipCursorWidth(tooltipCursorWidth)
    setBarSize(barSize)
  }, [data])

  const initChart = ref => {
    chartRef.current = ref
  }

  return {
    barSize,
    tooltipCursorWidth,
    initChart,
    updateBarAndCursorWidth
  }
}
